export default __webpack_public_path__ + "static/logo-842b08bfb68c85428b74cdd2876695f2.svg";